

import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import LCChooser from "@/components/locker/widget/LCChooser.vue";
import {IAuthUserData} from "@/store/modules/authModule";
import {IOnOffHandlers} from "bonomo/dist";
import {ILocker} from "@/model/Locker/lockerInterfaces";
import {flattenErrors} from "@/helpers/errorsHelper";
import {Prop, Watch} from "vue-property-decorator";
import {IShortUser} from "@/model/shortInterfaces";

  const userModule = namespace("userModule");
  const authModule = namespace("authModule");
  const lockerModule = namespace("lockerModule");
  const orderModule = namespace("orderModule");

  @Component({
    name: 'UserPackageDelivery',
    components: {
      LCChooser
    }
  })
  export default class UserPackageDeliveryView extends Vue {

    @Prop()
    protected userId!: number;

    @userModule.Getter('shortUser')
    private user!: IShortUser;
    @authModule.Getter('userData')
    private authUser!: IAuthUserData;
    @lockerModule.Getter('lockers')
    private lockers!: ILocker[];
    @lockerModule.Getter('availableCells')
    private availableCells!: any;
    @orderModule.Getter('order')
    private orderCreated!: any;
    @orderModule.Getter('errors')
    private errors!: any;

    @Watch('userId')
    onRouteChanged() {
      this.loadData();
    }

    private subscribes: IOnOffHandlers = {};
    private nextUserId: number = 0;
    private submitting: boolean = false;
    private lockersLoaded: boolean = false;
    private cellsLoaded: boolean = false;
    private selectedLockerId: number = 0;
    private selectedCellSizeId: number = 0;
    private selectedOpenRemote: boolean = true;
    private selectedCourier: string = 'manual';

    get lockerItems() {
      return this.lockers.map((eachLocker: any) => ({
        text: eachLocker.name,
        value: eachLocker.id,
      }));
    }

    get flatErrors() {
      return flattenErrors(this.errors || {});
    }

    created() {
      this.subscribes = this.$ons({
        'login.OK': this.loadData,
        'backend.call.begin': this.onBackendCall,
        'backend.call.OK': this.onBackendCallOK,
        'backend.call.KO': this.onBackendCallKO,
        'backend.call.OK.shortUserLoaded': this.onLockersLoadedOK,
        'backend.call.KO.shortUserLoaded': this.onInvalidTargetUserId,
        'backend.call.OK.lockersLoaded': this.onLockersLoadedOK,
        'backend.call.OK.orderCreated': this.onOrderCreatedOK,
        'backend.call.KO.orderCreated': this.onOrderCreatedKO,
        'backend.call.OK.availableCellsLoaded': this.onCellsLoaded,
      });
      this.loadData();
    }
    beforeDestroy() {
      this.$offs(this.subscribes);
    }
    loadData() {
      if (!this.userId) {
        this.onInvalidTargetUserId();
      }
      this.nextUserId = this.userId;
      this.selectedLockerId = 0;
      this.$store.dispatch('userModule/fetchShortUser', this.$route.params.userId);
      this.$store.dispatch('lockerModule/fetchLockers');
    }
    onInvalidTargetUserId() {
      this.$router.go(-1);
    }
    onGotoUser() {
      this.$router.push({name: 'userPackageDelivery', params: {userId: ''+this.nextUserId}});
    }

    onLockersLoadedOK() {
      // try to (pre)select target user's locker ID if it's available
      if (this.user && this.user.locker_id ) {
        const locker = this.lockers.find(each => each.id == this.user.locker_id);
        if (locker) {
          this.selectedLockerId = locker.id;
          this.onLockerSelected();
        }
      }
      setTimeout(() => {
        this.lockersLoaded = true;
      }, 1);
    }

    onLockerSelected() {
      this.cellsLoaded = true;
      this.cellsLoaded = false;
      this.selectedCellSizeId = 0;
      this.$store.dispatch("lockerModule/availableCells", this.selectedLockerId);
    }

    onCellsLoaded() {
      this.cellsLoaded = true;
      this.selectedCellSizeId = 0;
    }

    onCellSelected(id: number) {
      this.selectedCellSizeId = id;
    }

    onSubmit() {
      this.$store.dispatch('orderModule/createPackageDelivery', {
        userId: this.userId,
        lockerId: this.selectedLockerId,
        cellSizeId: this.selectedCellSizeId,
        openRemote: this.selectedOpenRemote
      });
    }

    onBackendCall() {
      this.submitting = true;
    }
    onBackendCallOK() {
      this.submitting = false;
    }
    onBackendCallKO() {
      this.submitting = false;
      this.$uiBus.emit('alert', 'backend KO');
    }
    onOrderCreatedOK() {
      setTimeout(() => {
        this.submitting = true;
        this.$router.push({name: 'order', params: { orderId: this.orderCreated.id}});
      }, 1);
    }
    onOrderCreatedKO() {
      this.submitting = false;
    }
  }
